import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { dropDown } from 'src/app/modules/_models/components-types.interface';
import { UUIDGenerator } from 'src/app/utils/uuid-generator';

@Component({
  selector: 'shared-dropdown-lovers',
  templateUrl: './dropdown-lovers.component.html',
  styleUrls: ['./dropdown-lovers.component.scss'],
})
export class DropdownLoversComponent implements OnInit {
  @Input() valores: dropDown[] = [];
  @Input() controlName: string = '';
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() labelCampoValidado: string = '';
  @Input() mensagemGenerica: string = '';
  @Input() maxlength: number;
  @Input() tab: number;

  public formGroup!: FormGroup;

  public idCampo: string = '';
  public isInputFocused: boolean = false;


  constructor(
    private formGroupDirective: FormGroupDirective,
    private UUID: UUIDGenerator
  ) {}

  ngOnInit(): void {
    this.idCampo = this.UUID.gerarUUID();
    this.formGroup = this.formGroupDirective.form;
  }

  onInputFocus(): void {
    this.isInputFocused = true;
  }

  onInputBlur(): void {
    this.isInputFocused = false;
  }
}
